import React from "react";
import HeroBanner from "../components/HeroBanner";
import CategoryGrid from "../components/CategoryGrid";
import FeaturedProducts from "../components/FeaturedProducts";
import CategorySections from "../components/CategorySections";
import FloatingButtons from "../components/FloatingButton";

const Home = () => {
  return (
    <div>
      <HeroBanner />
      <CategorySections />
      {/* <CategoryGrid />
      <FeaturedProducts /> */}
      <FloatingButtons />
      
    </div>
  );
};

export default Home;
